import React, { useEffect, useCallback, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from 'shared/components/MenuItem';
import omit from 'lodash/omit';
import styled from 'styled-components';
import { withStyles } from '@mui/styles';

import { queryToSearch, useSearch } from './makeNav';

export default function NavSelect({
  name,
  options,
  defaultValue,
  onValue,
  hasCheckbox = true,
  minWidth = 100,
  defaultOption = false,
  styles = {},
  ...props
}) {
  const { pathname } = useLocation();
  const query = useSearch();
  const tokenIndex = name.startsWith(':')
    ? parseInt(name.substring(1))
    : null;
  const value = tokenIndex === null
    ? query[name] ?? defaultOption
    : pathname.split('/')[tokenIndex];
  const { push } = useHistory();
  const handleChange = useCallback(event => {
    const to = tokenIndex
      ? pathname
          .split('/')
          .map((token, index) => index === tokenIndex ? event.target.value : token)
          .join('/')
          + `?${queryToSearch(query)}`
      : event.target.value !== null
        ? `${pathname}?${queryToSearch({ ...query, [name]: event.target.value })}`
        : omit(query, name);
    push(to);
  }, [pathname, name, push, onValue]);
  const checkboxHref = value
    ? `${pathname}?${queryToSearch(omit(query, name))}`
    : `${pathname}?${queryToSearch({ ...query, [name]: defaultValue })}`;
  const handleCheck = useCallback(event => {
    push(checkboxHref);
  }, [checkboxHref]);

  useEffect(() => {
    try {
      if (onValue) {
        onValue(value);
      }
    } catch (e) { /* empty */ }
  }, [onValue, value]);
  const style = useMemo(() => ({
    minWidth: `${minWidth}px`,
    ...styles
  }), [minWidth]);

  return (
    <>
      {hasCheckbox && (
        <Checkbox
          checked={Boolean(value)}
          component="a"
          href={checkboxHref}
          onChange={handleCheck}
        />)}
      <Select
        {...props}
        value={value || defaultValue}
        {...{ name, options, style }}
        onChange={handleChange}
        disabled={hasCheckbox && !value}
      >
        {options.map(({ value, label }) => (
          <MenuItem
            key={value}
            {...{ value }}
          >
            {label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
}

const Select = styled(TextField).attrs({
  select: true,
})`
`;

/*styled(MenuItemMui)`
  .MuiMenuItem-root {
    min-height: 64px !important;
  }
  .Mui-selected{
    background-color: #EAF0F6 !important;
  }
  .MuiList-root .MuiListItem-root {
    min-height: 64px !important;
  }
`*/